import { makeAutoObservable, runInAction } from 'mobx';
import { api } from '@/shared/api/api';

export interface MailNotification {
  id: number;
  subject: string;
  text: string;
  sender: { id: number; name?: string; username?: string } | null;
  created_at: string;
  is_read: boolean;
  special_type?: string; // PM, UPDATE, SUPPORT, EXTERNAL
}

export class NotificationsStore {
  notifications: MailNotification[] = [];
  unreadCount = 0;
  isLoading = false;
  isOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  setOpen(v: boolean) {
    this.isOpen = v;
  }

  async fetch() {
    this.isLoading = true;
    try {
      const res = await api.get('/api/v1/mails', {
        params: { folder: 'INBOX', offset: 0, limit: 20 },
      });
      runInAction(() => {
        this.notifications = res.data?.results || [];
        this.unreadCount = res.data?.unreadCount || 0;
      });
    } catch {
      // silently fail
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async markAsRead(ids: number[]) {
    if (!ids.length) return;
    try {
      await api.get(`/api/v1/mails-set-readable?ids=${ids.join(',')}`);
      runInAction(() => {
        for (const n of this.notifications) {
          if (ids.includes(n.id)) n.is_read = true;
        }
        this.unreadCount = this.notifications.filter((n) => !n.is_read).length;
      });
    } catch {
      // silently fail
    }
  }

  async markAllAsRead() {
    const unreadIds = this.notifications.filter((n) => !n.is_read).map((n) => n.id);
    await this.markAsRead(unreadIds);
  }

  async deleteNotification(id: number) {
    try {
      await api.get(`/api/v1/mails-delete?ids=${id}`);
      runInAction(() => {
        this.notifications = this.notifications.filter((n) => n.id !== id);
        this.unreadCount = this.notifications.filter((n) => !n.is_read).length;
      });
    } catch {
      // silently fail
    }
  }
}
